const de_DE = {}

de_DE.strings = {
  addMoreFiles: 'Dateien hinzufügen',
  addingMoreFiles: 'Dateien hinzufügen',
  allowAccessDescription: 'Um Bilder oder Videos mit Ihrer Kamera aufzunehmen, erlauben Sie dieser Website bitte Zugriff auf Ihre Kamera.',
  allowAccessTitle: 'Bitte erlauben Sie Zugriff auf Ihre Kamera',
  authenticateWith: 'Mit %{pluginName} verbinden',
  authenticateWithTitle: 'Bitte authentifizieren Sie sich mit %{pluginName}, um Dateien auszuwählen',
  back: 'Zurück',
  addMore: 'Dateien hinzufügen',
  browse: 'Suche',
  browseFiles: 'Suche',
  cancel: 'Abbrechen',
  cancelUpload: 'Upload abbrechen',
  chooseFiles: 'Dateien auswählen',
  closeModal: 'Modal schließen',
  companionError: 'Verbindung zu Companion fehlgeschlagen',
  complete: 'Fertig',
  connectedToInternet: 'Verbunden mit dem Internet',
  copyLink: 'Link kopieren',
  copyLinkToClipboardFallback: 'Untenstehenden URL kopieren',
  copyLinkToClipboardSuccess: 'Link in die Zwischenablage kopiert',
  creatingAssembly: 'Upload vorbereiten...',
  creatingAssemblyFailed: 'Transloadit: Konnte Assembly nicht erstellen',
  dashboardTitle: 'Datei Uploader',
  dashboardWindowTitle: 'Datei Uploader Fenster (Esc drücken zum Schließen)',
  dataUploadedOfTotal: '%{complete} von %{total}',
  done: 'Abgeschlossen',
  dropHereOr: 'Dateien können über Drag/Drop oder per %{browse} hinzugefügt werden',
  dropHint: 'Dateien können über Drag/Drop hinzugefügt werden',
  dropPasteBoth: 'Dateien können über Drag/Drop, Einfügen oder per %{browse} hinzugefügt werden',
  dropPasteFiles: 'Dateien können über Drag/Drop, Einfügen oder per %{browse} hinzugefügt werden',
  dropPasteFolders: 'Dateien können über Drag/Drop, Einfügen oder per %{browse} hinzugefügt werden',
  dropPasteImportBoth: 'Dateien können über Drag/Drop, Einfügen, per %{browse} oder von folgenden Services hinzugefügt werden',
  dropPasteImportFiles: 'Dateien können über Drag/Drop, Einfügen, per %{browse} oder von folgenden Services hinzugefügt werden',
  dropPasteImportFolders: 'Dateien können über Drag/Drop, Einfügen, per %{browse} oder von folgenden Services hinzugefügt werden',

  editFile: 'Datei bearbeiten',
  editing: '%{file} bearbeiten',
  emptyFolderAdded: 'Keine Dateien konnten hinzugefügt werden, da der Ordner leer war',
  encoding: 'Enkodieren...',
  enterCorrectUrl: 'Falsche URL: Bitte stellen Sie sicher, dass Sie einen direkten Link zu einer Datei eingeben',
  enterUrlToImport: 'URL zum Importieren einer Datei eingeben',
  exceedsSize: 'Diese Datei ist größer als die maximal erlaubte Dateigröße',
  failedToFetch: 'Companion konnte diese URL nicht verarbeiten - stellen Sie bitte sicher, dass sie korrekt ist',
  failedToUpload: 'Fehler beim Upload von Datei %{file}',
  fileSource: 'Dateiquelle: %{name}',
  filesUploadedOfTotal: {
    '0': '%{complete} von %{smart_count} Datei hochgeladen',
    '1': '%{complete} von %{smart_count} Dateien hochgeladen',
    '2': '%{complete} von %{smart_count} Dateien hochgeladen',
  },
  filter: 'Filter',
  finishEditingFile: 'Dateibearbeitung beenden',
  folderAdded: {
    '0': '%{smart_count} Datei von %{folder} hinzugefügt',
    '1': '%{smart_count} Dateien von %{folder} hinzugefügt',
    '2': '%{smart_count} Dateien von %{folder} hinzugefügt',
  },
  import: 'Import',
  importFrom: 'Importieren von %{name}',
  loading: 'Laden...',
  logOut: 'Ausloggen',
  myDevice: 'Mein Gerät',
  noCameraDescription: 'Bitte Kamera anschließen, um Bilder oder Videos aufzunehmen',
  noCameraTitle: 'Kamera nicht verfügbar',
  noDuplicates: 'Datei \'%{fileName}\' existiert bereits und kann nicht erneut hinzugefügt werden',
  noFilesFound: 'Sie haben keine Dateien oder Ordner hier',
  noInternetConnection: 'Keine Internetverbindung',
  noNewAlreadyUploading: 'Während der Upload läuft, können keine weiteren Dateien hinzugefügt werden',
  pause: 'Pausieren',
  pauseUpload: 'Upload pausieren',
  paused: 'Pausiert',
  poweredBy: 'Angetrieben von',
  processingXFiles: {
    '0': '%{smart_count} Datei verarbeiten',
    '1': '%{smart_count} Dateien verarbeiten',
    '2': '%{smart_count} Dateien verarbeiten',
  },
  recordingLength: 'Aufnahmedauer %{recording_length}',
  removeFile: 'Datei entfernen',
  resetFilter: 'Filter zurücksetzen',
  resume: 'Fortsetzen',
  resumeUpload: 'Upload fortsetzen',
  retry: 'Erneut versuchen',
  retryUpload: 'Upload erneut versuchen',
  saveChanges: 'Änderungen speichern',
  selectX: {
    '0': 'Wählen Sie %{smart_count}',
    '1': 'Wählen Sie %{smart_count}',
    '2': 'Wählen Sie %{smart_count}',
  },
  smile: 'Bitte lächeln!',
  startRecording: 'Videoaufnahme starten',
  stopRecording: 'Videoaufnahme beenden',
  takePicture: 'Ein Foto machen',
  timedOut: 'Upload für %{seconds} Sekunden stehen geblieben, breche ab.',
  upload: 'Upload',
  uploadComplete: 'Upload beendet',
  uploadFailed: 'Upload fehlgeschlagen',
  uploadPaused: 'Upload pausiert',
  uploadXFiles: {
    '0': '%{smart_count} Datei hochladen',
    '1': '%{smart_count} Dateien hochladen',
    '2': '%{smart_count} Dateien hochladen',
  },
  uploadXNewFiles: {
    '0': '+%{smart_count} Datei hochladen',
    '1': '+%{smart_count} Dateien hochladen',
    '2': '+%{smart_count} Dateien hochladen',
  },
  uploading: 'Uploading',
  uploadingXFiles: {
    '0': '%{smart_count} Datei wird hochgeladen',
    '1': '%{smart_count} Dateien werden hochgeladen',
    '2': '%{smart_count} Dateien werden hochgeladen',
  },
  xFilesSelected: {
    '0': '%{smart_count} Datei ausgewählt',
    '1': '%{smart_count} Dateien ausgewählt',
    '2': '%{smart_count} Dateien ausgewählt',
  },
  xMoreFilesAdded: {
    '0': '%{smart_count} weitere Datei hinzugefügt',
    '1': '%{smart_count} weitere Dateien hinzugefügt',
    '2': '%{smart_count} weitere Dateien hinzugefügt',
  },
  xTimeLeft: '%{time} verbleibend',
  youCanOnlyUploadFileTypes: 'Sie können nur folgende Dateitypen hochladen: %{types}',
  youCanOnlyUploadX: {
    '0': 'Sie können nur %{smart_count} Datei hochladen',
    '1': 'Sie können nur %{smart_count} Dateien hochladen',
    '2': 'Sie können nur %{smart_count} Dateien hochladen',
  },
  youHaveToAtLeastSelectX: {
    '0': 'Sie müssen mindestens %{smart_count} Datei auswählen',
    '1': 'Sie müssen mindestens %{smart_count} Dateien auswählen',
    '2': 'Sie müssen mindestens %{smart_count} Dateien auswählen',
  },
  selectAllFilesFromFolderNamed: 'Wählen Sie alle Dateien aus dem Ordner %{name}',
  unselectAllFilesFromFolderNamed: 'Heben Sie die Auswahl aller Dateien aus dem Ordner auf %{name}',
  selectFileNamed: 'Datei aussuchen %{name}',
  unselectFileNamed: 'Datei abwählen %{name}',
  openFolderNamed: 'Ordner öffnen %{name}',
}

de_DE.pluralize = function (n) {
  if (n === 1) {
    return 0
  }
  return 1
}

if (typeof window !== 'undefined' && typeof window.Uppy !== 'undefined') {
  window.Uppy.locales.de_DE = de_DE
}

module.exports = de_DE
